import React from 'react';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { BLANK } from '@yme/utils/constants';
import { LinkStyled } from '../../CardAccessories/styled';
export const SizeGuideButton = ({ viewSizeGuideLabel, viewSizeGuide, sizeGuideAssetPath, asComponent, onClick, }) => (React.createElement(FlexWrapper, { ml: "auto" },
    React.createElement(SVGIcon, { type: viewSizeGuide, size: ICON_SIZE.s }),
    React.createElement(LinkStyled, { as: asComponent, href: sizeGuideAssetPath || undefined, target: sizeGuideAssetPath ? BLANK : undefined, weight: 400, color: colorCoreBlack900Base, onClick: () => (onClick ? onClick() : null) }, viewSizeGuideLabel)));
